export class GuidelinesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async uploadPdf({ file, signal }) {
    const formData = new FormData();
    formData.append('file', file);

    return this.#http.post('/guidelines/pdf-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      signal,
    });
  }

  async importFromPdf(body, { signal } = {}) {
    return this.#http.post('/guidelines/import-from-pdf', body, { signal });
  }

  async startBuiltInImport(body, { signal } = {}) {
    return this.#http.post('/guidelines/import-builtin', body, { signal });
  }

  async getImportJob(jobId, { signal } = {}) {
    return this.#http.get(`/guidelines/import-jobs/${jobId}`, { signal });
  }

  async listImportJobs({ sourceId, limit, signal } = {}) {
    return this.#http.get('/guidelines/import-jobs', {
      params: { sourceId, limit },
      signal,
    });
  }

  async getSources({ signal } = {}) {
    return this.#http.get('/guidelines/sources', { signal });
  }

  async getSourceById(id, { signal } = {}) {
    return this.#http.get(`/guidelines/sources/${id}`, { signal });
  }

  async createSource(body, { signal } = {}) {
    return this.#http.post('/guidelines/sources', body, { signal });
  }

  async updateSource({ id, ...body }, { signal } = {}) {
    return this.#http.put(`/guidelines/sources/${id}`, body, { signal });
  }

  async deleteSource(id, { signal } = {}) {
    return this.#http.delete(`/guidelines/sources/${id}`, { signal });
  }

  async getVersionsBySource(sourceId, { signal } = {}) {
    return this.#http.get(`/guidelines/sources/${sourceId}/versions`, { signal });
  }

  async getLatestVersionBySource(sourceId, { signal } = {}) {
    return this.#http.get(`/guidelines/sources/${sourceId}/versions/latest`, { signal });
  }

  async getVersionById(id, { signal } = {}) {
    return this.#http.get(`/guidelines/versions/${id}`, { signal });
  }

  async createVersion({ sourceId, ...body }, { signal } = {}) {
    return this.#http.post(`/guidelines/sources/${sourceId}/versions`, body, { signal });
  }

  async deleteVersion(id, { signal } = {}) {
    return this.#http.delete(`/guidelines/versions/${id}`, { signal });
  }

  async getVersionToc(versionId, { signal } = {}) {
    return this.#http.get(`/guidelines/versions/${versionId}/toc`, { signal });
  }

  async getSectionsByVersion({ versionId, ...params }, { signal } = {}) {
    return this.#http.get(`/guidelines/versions/${versionId}/sections`, { params, signal });
  }

  async lookupSection({ sourceId, sectionNumber }, { signal, ...config } = {}) {
    return this.#http.get('/guidelines/sections/lookup', {
      ...config,
      params: { sourceId, sectionNumber },
      signal,
    });
  }

  async getSectionById(id, { signal, ...config } = {}) {
    return this.#http.get(`/guidelines/sections/${id}`, { ...config, signal });
  }

  async getChildSections(id, { signal } = {}) {
    return this.#http.get(`/guidelines/sections/${id}/children`, { signal });
  }

  async createSection({ versionId, ...body }, { signal } = {}) {
    return this.#http.post(`/guidelines/versions/${versionId}/sections`, body, { signal });
  }

  async updateSection({ id, ...body }, { signal } = {}) {
    return this.#http.put(`/guidelines/sections/${id}`, body, { signal });
  }

  async deleteSection(id, { signal } = {}) {
    return this.#http.delete(`/guidelines/sections/${id}`, { signal });
  }

  async getChunksBySection(sectionId, { signal } = {}) {
    return this.#http.get(`/guidelines/sections/${sectionId}/chunks`, { signal });
  }

  async regenerateChunkEmbedding(chunkId, { signal } = {}) {
    return this.#http.post(`/guidelines/chunks/${chunkId}/regenerate-embedding`, null, { signal });
  }

  async runImport(body, { signal } = {}) {
    return this.#http.post('/guidelines/actions/import', body, { signal });
  }

  async runGenerateMissingChunks(body, { signal } = {}) {
    return this.#http.post('/guidelines/actions/generate-missing-chunks', body, { signal });
  }

  async runRegenerateEmbeddings(body, { signal } = {}) {
    return this.#http.post('/guidelines/actions/regenerate-embeddings', body, { signal });
  }
}
